module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"修改密码":"Change Password","旧密码":"Old Password","新密码":"New Password","确认密码":"Confirm Password","请输入原始密码":"Please enter the old password","请输入新密码":"Please enter the new password","两次输入密码不一致":"The confirm password is different","长度在 5 到 10 个字符":"The length is between 5 and 10 characters","密码修改成功，请重新登录！":"Password modified successfully, please login again!"}}')
  delete Component.options._Ctor
}
